(function () {
  const REQUIRED_MESSAGE = 'Please enter your phone number.';

  function markPhoneRequired(input) {
    if (!(input instanceof HTMLInputElement) || input.type !== 'tel') return;

    input.required = true;
    input.setAttribute('aria-required', 'true');

    if (input.placeholder && !input.placeholder.includes('*')) {
      input.placeholder = `${input.placeholder} *`;
    }

    const label = input.id ? document.querySelector(`label[for="${CSS.escape(input.id)}"]`) : null;
    if (label && !label.textContent.includes('*')) {
      label.append(' *');
    }

    input.addEventListener('input', () => input.setCustomValidity(''), { once: true });
  }

  function markAllPhoneFields(root) {
    root.querySelectorAll('input[type="tel"]').forEach(markPhoneRequired);
  }

  function validateRequiredPhone(event) {
    const phone = event.target.querySelector('input[type="tel"]');
    if (!phone) return;

    markPhoneRequired(phone);
    phone.setCustomValidity('');

    if (!phone.value.trim()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      phone.setCustomValidity(REQUIRED_MESSAGE);
      phone.reportValidity();
      phone.focus();
    }
  }

  document.addEventListener('DOMContentLoaded', () => markAllPhoneFields(document));
  document.addEventListener('shopify:section:load', (event) => markAllPhoneFields(event.target));
  document.addEventListener('submit', validateRequiredPhone, true);
})();
